/**
 * Takes a string and a key-value plain JS object, or array of values.
 *
 * If an array, replace {0}, {1}, etc in the string with the elements of the array in order.
 *
 * If an object, replace {varname} by name in the string from the values of the corresponding property of the object.
 * @param  {String}         string     A string with appropriately formatted sections to be replaced with values from objOrArray.
 * @return {Array | Object} objOrArray An object with values keyed by property names, or an array of values, to use to parameterize the string string.
 */
export const template = (string, objOrArray) => {
  const isObjOrArray =
    Array.isArray(objOrArray) ||
    (typeof objOrArray === 'object' && objOrArray !== null);
  if (typeof string !== 'string' || !isObjOrArray) {
    return false;
  }

  let s = string;

  if (Array.isArray(objOrArray)) {
    const arr = objOrArray;
    s = string.replace(/({\d})/g, function (i) {
      return arr[i.replace(/{/, '').replace(/}/, '')];
    });
  } else {
    const obj = objOrArray;

    Object.keys(obj).forEach((prop) => {
      s = s.replace(new RegExp('{' + prop + '}', 'g'), obj[prop]);
    });
  }

  return s;
};
